// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";

type Props = {
  onDismissHandler: () => void,
  onSubmit: () => void,
  alertName: string,
  ...PropsFromLocalize,
};

export const ExcludeEmployeeFromAlertsRemoveModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader className="d-flex justify-content-between" toggle={props.onDismissHandler}>
      {props.t("REMOVE_ALERT_EXCLSUION_MODAL_TITLE")}
    </ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p>{props.t("REMOVE_ALERT_EXCLSUION_CONFIRMATION", { alertName: props.alertName })}</p>
    </ModalBody>
    <ModalFooter className="d-flex justify-content-end">
      <Button color="secondary" onClick={props.onDismissHandler}>
        {props.t("CANCEL")}
      </Button>
      <Button materialIcon="delete_forever" onClick={props.onSubmit}>
        {props.t("DELETE")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default localize()(ExcludeEmployeeFromAlertsRemoveModal);
